import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, contracterActions } from '../../store/actions'
import Input from '../input'
import moment from 'moment'
import { commons } from '../../hook/common'
import Calendar from '../component-box/Calendar'

/**
 * 물품 등록/수정 팝업
 * @param props
 * @constructor
 */
const PopupAddItems = (props) => {
  const nodeBaseInfo = {
    itemCd: {
      title: '제품코드',
      type: 'text',
      length: 20,
    },
    hsCd: {
      title: 'HS부호',
      type: 'text',
      length: 20,
      required: true,
      message: 'HS부호를 입력해주세요.',
    },
    itemnm: {
      title: '품명',
      type: 'text',
      length: 100,
      required: true,
      message: '품명을 입력해주세요.',
    },
    companymngcd: {
      title: '자산관리코드',
      type: 'text',
      length: 10,
    },
    itemdeftxt: {
      title: '규격',
      type: 'text',
      length: 100,
    },
    notetxt: {
      title: '비고',
      type: 'text',
      length: 100,
    },
    baseAmt: {
      title: '단가',
      type: 'number',
      required: true,
      message: '단가를 입력해주세요.',
      withInput: 'KRW',
    },
    baseCnt: {
      title: '단위수량',
      type: 'number',
      required: true,
      message: '단위수량을 입력해주세요.',
    },
    grcnt: {
      title: '총수량',
      type: 'number',
      required: true,
      message: '총수량을 입력해주세요.',
    },
    gramt: {
      title: '총금액',
      type: 'number',
      required: true,
      message: '총금액을 입력해주세요.',
    },
    crtYmd: {
      title: '구매일자',
    },
  }

  const inputRef = React.useRef(new Array(Object.keys(nodeBaseInfo).length))
  const [state, setState] = useState({})
  const [nodeInfo, setNodeInfo] = useState(nodeBaseInfo)
  const [reset, setReset] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editIdx, setEditIdx] = useState(-1)
  const [itemList, setItemList] = useState(props.stepData)
  const [itemInput, setItemInput] = useState({})
  const [selectItems, setSelectItems] = useState([])

  /**
   * 화면집입시 초기값 세팅
   */
  useEffect(() => {
    let list = JSON.parse(sessionStorage.getItem(props.docid)).step2

    setItemList(list)
    commons.preventKeyDown()
  }, [])

  /**
   * 데이터 저장 후 입력폼 갱신
   */
  useEffect(() => {
    if (props.isCalled === true && !props.isFailure) {
      setItemList(props?.stepData)
      setReset(true)
      newInput()
    }
    props.setCalled(false)
  }, [props?.isCalled])

  /**
   * input 갱신을 위한 hook
   */
  useEffect(() => {
    if (reset === true) setReset(false)
  }, [reset])

  /**
   * 입력학목 유효성 체크 및 저장 api 호출
   */
  const saveItem = () => {
    setState({ ...state, submitted: !state.submitted, errCrtYmd: '' })

    let node = nodeInfo
    let errCnt = 0
    let isFocus = false

    Object.keys(node).forEach((key, index) => {
      let message = null

      //필수 체크
      if (node[key].required) {
        if (!itemInput?.[key] || itemInput?.[key]?.length <= 0) {
          message = node[key]?.message
          errCnt++
        }
      }

      node[key].errMessage = message

      if (!isFocus && errCnt === 1) {
        isFocus = true
        inputRef.current[index].focus()
      }
    })

    if (!itemInput.crtYmd || itemInput.crtYmd?.length <= 0) {
      setState({ ...state, errCrtYmd: '구매일자를 선택해주세요.' })
      errCnt++
    }

    if (errCnt > 0) return

    itemInput.totamtcur = props.currency
    props.saveStep(props.docid, '2', itemInput, isEdit)
  }

  /**
   * 물품정보 수정
   * @param seq
   */
  const selectEdit = (crtItemSeq, index = -1) => {
    if (editIdx === index) {
      newInput()
    } else {
      setItemInput({ ...itemList[itemList.findIndex((item) => item.crtItemSeq === crtItemSeq)] })
      setIsEdit(true)
      setEditIdx(index)
    }
  }

  /**
   * 새로작성
   */
  const newInput = () => {
    setState({ ...state, errCrtYmd: '' })
    let node = nodeInfo
    Object.keys(node).forEach((key, index) => {
      node[key].errMessage = null
    })

    setSelectItems([])
    setItemInput({})
    setIsEdit(false)
    setEditIdx(-1)
    setReset(true)
  }

  /**
   * 선택삭제
   * @returns {*}
   */
  const deleteItems = () => {
    if (selectItems?.length <= 0) {
      return props.error({ message: '삭제할 물품을 선택해주세요.' })
    }

    props.confirm({
      title: '확인',
      message: '정말 삭제하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          props.deleteStepItems(props.docid, '2', selectItems)
        },
      },
    })
  }

  /**
   * 전체삭제
   */
  const deleteAll = () => {
    itemList?.length > 0 &&
      props.confirm({
        title: '확인',
        message: '정말 삭제하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            props.deleteStepItemAll(props.docid, '2')
          },
        },
      })
  }

  const handleClose = () => {
    props.onClose()
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    let obj = {
      ...itemInput,
      [name]: value,
    }

    if (name === 'baseAmt') {
      itemInput.grcnt?.length > 0 && (obj.gramt = parseInt(value) * parseInt(itemInput.grcnt))
    }

    if (name === 'grcnt') {
      itemInput.baseAmt?.length > 0 && (obj.gramt = parseInt(value) * parseInt(itemInput.baseAmt))
    }

    setItemInput(obj)
  }

  const onSelectItem = (e) => {
    const { name, checked } = e.target
    let list = selectItems
    if (checked) {
      list.push(name)
    } else {
      list = selectItems.filter((item) => item !== name)
    }
    setSelectItems(list)
  }

  const generateInput = (key) => {
    const node = nodeInfo[key]
    let idx = Object.keys(nodeBaseInfo).findIndex((objKey) => objKey === key)
    let className = 'form-control input-text '
    let wrapperClassName = node?.wrapperClassName
    let maxLength = node.length
    !maxLength && node?.type === 'number' && (maxLength = 16)
    node?.readOnly === true && (className += 'disabled ')

    return (
      <Input
        id={key}
        name={key}
        type={node.type}
        inputTitle={node?.inputTitle ? node?.inputTitle : node?.title}
        value={itemInput?.[key] || ''}
        ref={(ref) => (inputRef.current[idx] = ref)}
        wrapperClassName={wrapperClassName}
        className={className + node?.className}
        placeholder={node?.placeholder}
        message={node?.message}
        onChange={handleChange}
        readOnly={node.readOnly}
        required={node.required}
        flow={node.flow ? node.flow : `${window.innerWidth >= 767 ? 'left' : 'up'}`}
        length={maxLength}
        errMessage={node.errMessage}
      />
    )
  }

  return (
    <React.Fragment>
      <div className="modal-overlay normal modal-certificate">
        <div className="modal modal-Full">
          <div className="modal-content">
            <div className="modal-header flex-sb">
              <div className="modal-title dis-flex">구매물품 목록</div>

              <button type="button" className="icon-close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="lineBox">
                <ul className="step-detail">
                  <li className="flex-l m-b-10">
                    <h4 className="title">제품코드</h4>
                    {generateInput('itemCd')}
                  </li>
                  <li className="flex-l m-b-10">
                    <h4 className="title">
                      HS부호 <span className="required">*</span>
                    </h4>
                    {generateInput('hsCd')}
                  </li>
                  <li className="flex-l m-b-10">
                    <h4 className="title">
                      품명 <span className="required">*</span>
                    </h4>
                    {generateInput('itemnm')}
                  </li>
                  <li className="flex-l m-b-10">
                    <h4 className="title">자산관리코드</h4>
                    {generateInput('companymngcd')}
                  </li>
                  <li className="flex-l m-b-10">
                    <h4 className="title">규격</h4>
                    {generateInput('itemdeftxt')}
                  </li>
                  <li className="flex-l m-b-10">
                    <h4 className="title">비고</h4>
                    {generateInput('notetxt')}
                  </li>
                  <li className=" m-b-10">
                    <div className="flex-l type-text-input">
                      <h4 className="title">
                        단가 <span className="required">*</span>
                      </h4>
                      <span className="des W-5">{props.currency}</span>
                      {generateInput('baseAmt')}
                    </div>
                  </li>
                  <li className="flex-l m-b-10">
                    <h4 className="title">
                      단위수량 <span className="required">*</span>
                    </h4>
                    {generateInput('baseCnt')}
                  </li>
                  <li className="flex-l m-b-10">
                    <h4 className="title">
                      수량 <span className="required">*</span>
                    </h4>
                    {generateInput('grcnt')}
                  </li>
                  <li className="m-b-10">
                    <div className="flex-l type-text-input">
                      <h4 className="title">
                        총금액 <span className="required">*</span>
                      </h4>
                      <span className="des W-5">{props.currency}</span>
                      {generateInput('gramt')}
                    </div>
                  </li>
                  <li className="flex-l">
                    <h4 className="title">
                      구매일자 <span className="required">*</span>
                    </h4>
                    <div className="input-wrapper ">
                      {reset === false && (
                        <Calendar
                          default={itemInput.crtYmd && moment(itemInput.crtYmd, 'YYYYMMDD').format('YYYY-MM-DD')}
                          onSelect={(value) =>
                            setItemInput({
                              ...itemInput,
                              crtYmd: moment(value).format('YYYYMMDD'),
                            })
                          }
                        />
                      )}
                      {state.errCrtYmd && <div className={'input-error'}>{state.errCrtYmd}</div>}
                    </div>
                  </li>
                </ul>
              </div>

              <div className="title-btn m-t-20">
                <div className="dis-flex ">
                  <span className="totalPage w-50">총 {itemList?.length}건</span>
                  <div className="flex-r w-50">
                    <button className="btn btn-white" onClick={newInput}>
                      새로작성
                    </button>
                    <button className="btn btn-white" onClick={saveItem}>
                      {isEdit === true ? '수정' : '저장'}
                    </button>
                    <button className="btn btn-white" onClick={deleteItems}>
                      선택삭제
                    </button>
                    <button className="btn btn-white" onClick={deleteAll}>
                      전체삭제
                    </button>
                  </div>
                </div>
              </div>
              <div className="table">
                <div className="row header border">
                  <div className="cell w-7">선택</div>
                  <div className="cell w-10">HS부호</div>
                  <div className="cell ">품명</div>
                  <div className="cell w-10">규격</div>
                  <div className="cell w-10">수량</div>
                  <div className="cell w-10">구매일</div>
                  <div className="cell w-7">
                    단가
                    <br />({props.currency})
                  </div>
                  <div className="cell w-7">
                    금액
                    <br />({props.currency})
                  </div>
                </div>
                {itemList?.length > 0 ? (
                  itemList.map((item, index) => {
                    return (
                      <div className={'row ' + (isEdit && editIdx === index ? 'active' : '')} key={index}>
                        <div className="cell">
                          <input title={'checkbox' + index} type="checkbox" name={item.crtItemSeq} onChange={onSelectItem} />
                        </div>
                        <div className="cell" data-title={'HS부호'} onClick={() => selectEdit(item.crtItemSeq, index)}>
                          {item.hsCd}
                        </div>
                        <div className="cell" data-title={'품명'} onClick={() => selectEdit(item.crtItemSeq, index)}>
                          {item.itemnm}
                        </div>
                        <div className="cell" data-title={'규격'} onClick={() => selectEdit(item.crtItemSeq, index)}>
                          {item.itemdeftxt}
                        </div>
                        <div className="cell" data-title={'수량'} onClick={() => selectEdit(item.crtItemSeq, index)}>
                          {commons.addComma(item.grcnt)}
                        </div>
                        <div className="cell" data-title={'구매일'}>
                          {moment(item.crtYmd).format('YYYY-MM-DD')}
                        </div>
                        <div className="cell" data-title={'단가'}>
                          {commons.addComma(item.baseAmt)}
                        </div>
                        <div className="cell" data-title={'금액'}>
                          {commons.addComma(item.gramt)}
                        </div>
                      </div>
                    )
                  })
                ) : (
                  <div className="row noData">
                    <div className="cell">등록된 자료가 없습니다.</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    stepData: state.contracter?.data?.step2,
    isCalled: state.contracter.isCalled,
    isFailure: state.contracter.isFailure,
  }
}

const actionCreators = {
  saveStep: contracterActions.saveStep,
  setCalled: contracterActions.setCalled,
  error: alertActions.error,
  confirm: alertActions.confirm,
  deleteStepItems: contracterActions.deleteStepItems,
  deleteStepItemAll: contracterActions.deleteStepItemAll,
}

export default connect(mapStateToProps, actionCreators)(PopupAddItems)
